import { createContext } from "react";

const ImageGalleryContext = createContext({
  open: false,
  setOpen: null,
});

export default ImageGalleryContext;
